export default __webpack_public_path__ + "static/media/17.8a41618b.png";